import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { InstitutionsRoutingModule } from './institutions-routing.module';
import { InstitutionsListComponent } from './institutions-list/institutions-list.component';
import { InstitutionsCreateComponent } from './institutions-create/institutions-create.component';

@NgModule({
  declarations: [InstitutionsListComponent, InstitutionsCreateComponent],
  imports: [
    CommonModule,
    InstitutionsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class InstitutionsModule { }
